import React from 'react';
import { CoSellerModelIcon, SubstitutionModelIcon } from 'assests/GmsIcons';

type TypeSelectorProps = {
    value: "Co-seller" | "Substitution";
    onChange: (value: "Co-seller" | "Substitution") => void;
};

const TypeSelector: React.FC<TypeSelectorProps> = ({ value, onChange }) => {
    return (
        <div id={`type-selector`} className={`tw-px-3 tw-my-3`}>
            <div className="tw-text-sm tw-mb-2">Type</div>
            <div className="tw-flex tw-items-center tw-space-x-8">
                <label className="tw-flex tw-items-center tw-cursor-pointer tw-space-x-4">
                    <div className="tw-relative">
                        <input data-testid="components-typeselector-input-1"
                            type="radio"
                            className="tw-sr-only"
                            checked={value === "Co-seller"}
                            onChange={() => onChange("Co-seller")}
                        />
                        <div className="tw-w-4 tw-h-4 tw-bg-white tw-rounded-[44px] tw-border tw-border-[#091caa]">
                            {value === "Co-seller" && (
                                <div className="tw-w-2 tw-h-2 tw-bg-[#091caa] tw-rounded-full tw-absolute tw-top-1 tw-left-1" />
                            )}
                        </div>
                    </div>
                    <div className="tw-flex tw-items-center tw-space-x-2">
                        <CoSellerModelIcon />
                        <span className="tw-justify-start tw-text-[#172b4d] tw-text-sm">Co-Seller</span>
                    </div>
                </label>

                <label className="tw-flex tw-items-center tw-cursor-pointer tw-space-x-4">
                    <div className="tw-relative">
                        <input data-testid="components-typeselector-input-2"
                            type="radio"
                            className="tw-sr-only"
                            checked={value === "Substitution"}
                            onChange={() => onChange("Substitution")}
                        />
                        <div className="tw-w-4 tw-h-4 tw-bg-white tw-rounded-[44px] tw-border tw-border-[#091caa]">
                            {value === "Substitution" && (
                                <div className="tw-w-2 tw-h-2 tw-bg-[#091caa] tw-rounded-full tw-absolute tw-top-1 tw-left-1" />
                            )}
                        </div>
                    </div>
                    <div className="tw-flex tw-items-center tw-space-x-2">
                        <SubstitutionModelIcon />
                        <span className="tw-justify-start tw-text-[#172b4d] tw-text-sm">Substitution</span>

                    </div>
                </label>
            </div>
        </div>
    );
};

export default TypeSelector;